export enum StackType {
	NONE = 'none',
	NORMAL = 'normal',
	HUNDRED_PERCENT = 'hundred_percent',
}
